export enum PhoneNumberWhitelist {
    French1 = '+33650970455',
    German1 = '+491629182107',
    Belgian1 = '+32479986025',
}
